import Head from "next/head";
import { GetStaticProps } from "next";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AliceCarousel from "react-alice-carousel";
import { staff } from "../shared/utils/staff";
import { differentials } from "../shared/utils/differentials";
import styles from "../styles/pages/curriculo.module.scss";
import Header from "../components/Header";
import Title from "../components/Title";
import GenericCard from "../components/GenericCard";
// import LearningPath from "../components/_curriculo/LearningPath";
import CoachBanner from "../components/_curriculo/CoachBanner";
import GroupProjects from "../components/_curriculo/GroupProjects";
import StaffCard from "../components/_curriculo/StaffCard";
import DayByDay from "../components/_curriculo/DayByDay";
import Cta from "../components/Cta";
import Testimonials from "../components/_home/Testimonials";
import FloatLinks from "../components/FloatLinks";
import HardSkills from "../components/_curriculo/HardSkills";

export default function Curriculo() {
   const items = staff.map((instructor, index) => (
      <StaffCard
         key={instructor.name}
         name={instructor.name}
         image={instructor.image}
         description={instructor.description}
      />
   ));

   const responsive = {
      0: {
         items: 1,
      },
      838: {
         items: 2,
      },
      1349: {
         items: 3,
      },
   };

   useEffect(() => {
      AOS.init({
         disable: "mobile",
         duration: 700,
         easing: "ease-out-cubic",
         once: true,
      });
   }, []);

   return (
      <>
         <Head>
            <title>Curso de Programação Full Stack Online | Kenzie Academy</title>
            <meta
               name="description"
               content="Do Front end ao Back end. Curso de Programação Full Stack, com a melhor metodologia e conteúdo atualizado em HTML, CSS, JS, React, Python e mais."
            />
            <meta
               name="twitter:title"
               content="Curso de Programação Full Stack Online | Kenzie Academy"
            />
            <meta
               name="twitter:description"
               content="Do Front end ao Back end. Curso de Programação Full Stack, com a melhor metodologia e conteúdo atualizado em HTML, CSS, JS, React, Python e mais."
            />
            <meta
               property="og:title"
               content="Curso de Programação Full Stack Online | Kenzie Academy"
            />
            <link rel="canonical" href="https://kenzie.com.br/curriculo" />
         </Head>

         <Header />

         <main>
            <section className={styles.wrapper}>
               <div className={styles.background}>
                  <div className={styles.container}>
                     <div className={styles.contentContainer} data-aos="fade-right">
                        <h1 className={styles.title}>
                           Programe a sua evolução com a formação em programação da Kenzie
                        </h1>
                        <Cta
                           url="https://inscricao.kenzie.com.br"
                           maxWidthDesktop="28rem"
                           color="white"
                           passParams
                           text="Entrar na Lista de Espera"
                           centralized={false}
                           background
                        />
                     </div>
                  </div>
               </div>
            </section>
            <div className={`container ${styles.description}`}>
               <p>
                  Aqui na Kenzie, você aprende as principais linguagens e tecnologias de
                  programação para ser uma pessoa programadora pronta para o mercado de
                  trabalho em menos de 1 ano.
               </p>
               <p>
                  Pensando na melhor formação, nosso currículo conta com tecnologias Front
                  End e Back End. São mais de 1.600 horas de conteúdos e projetos para que
                  o aluno possa desenvolver hard e soft skills, formando assim um
                  profissional de programação completo.
               </p>
            </div>
            <HardSkills />
            {/* <LearningPath /> */}
            <DayByDay />
            <section className="container">
               <Title>Nossos diferenciais</Title>
               <div className="flex">
                  {differentials.map((diff, index) => (
                     <GenericCard
                        key={index}
                        content={diff}
                        background="#001e32"
                        textColor="#fff"
                     />
                  ))}
               </div>
            </section>
            <Testimonials mixedBackground={true} />
            <CoachBanner />
            {/* <GroupProjects />
            <section className={styles.teamSection}>
               <div className="container">
                  <Title>Conheça nosso time de ensino</Title>
                  <AliceCarousel
                     mouseTracking
                     items={items}
                     responsive={responsive}
                     infinite
                  />
               </div>
                  </section> */}
         </main>
         <FloatLinks />
      </>
   );
}

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
      revalidate: 60 * 60 * 24,
   };
};
